import { createContext } from 'react';

import { AnalyticsEngineInstance } from './types';

export const AnalyticsEngineContext = createContext<
  AnalyticsEngineInstance | undefined
>(undefined);
